<template lang="pug">
  .validating-body
    Card(
        v-for="user in userList"
        :data='user'
        :key="user.id"
        @click="clicked"
    )

    MainAsideRight(
        :isOpen="isOpen"
        :asideCanSave="canSave"
        storePath="coursesAnswerValidating")

        div {{userList.filter(el=> el.id === choosenCard)}}


</template>
<script>
import Card from './components/Card';
import MainAsideRight from '@/components/MainAsideRight/index';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Body',
  components: {
    Card,
    MainAsideRight
  },
  props: {
    type: {},
    userList: {}
  },
  data() {
    return {
      choosenCard: ''
    };
  },
  computed: {
    ...mapState('coursesAnswerValidating', {
      progressBar: s => s.data.progressBar,
      canSave: s => s.aside.meta.canSave,
      isOpen: s => s.aside.meta.isOpen
    })
  },
  methods: {
    ...mapActions('coursesAnswerValidating', [
      'getUserValidating',
      'setAsideMeta'
    ]),
    clicked(item) {
      this.choosenCard = item;
      this.getUserValidating({ id: item });
      this.setAsideMeta({ path: 'isOpen', value: true });
    }
  }
};
</script>
